import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { icons } from './assets/icons'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './Store/store'
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
React.icons = icons
ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
      <ToastContainer/>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
